import { component_tool, utils_tool } from '../../../tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import React from 'react'
import { WizTableForm } from '../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
let componentName = 'requirement'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "组织",
    name: "orgName",
    tableItem: {
      width: 120
    },
  },
  {
    title: "组织",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },
  {
    title: "岗位",
    name: "positionId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...positionConfig,
    }
  },
  {
    title: "岗位",
    name: "positionName",
    tableItem: {width: 150},
  },
  {
    title: "岗位所属分类",
    name: "positionCategoryCh",
    tableItem: {width: 150},
  },
  {
    title: '站点类型',
    name: 'dealerType',
    dict: [
      { code: 1, codeName: '4S网点' },
      { code: 2, codeName: '直营店' },
      { code: 3, codeName: '单一售后' },
      { code: 4, codeName: '单一销售' },
      { code: 5, codeName: '卫星店/直营店' },
      { code: 6, codeName: '自修站' },
      { code: 7, codeName: '卫星店' },
      { code: 8, codeName: '精品店' },
      { code: 9, codeName: 'dealer' },
      { code: 10, codeName: '4S店' },
      { code: 11, codeName: '汽车零售' },
      { code: 12, codeName: '单一销售展厅' },
      { code: 13, codeName: 'NEV单一售后' },
      { code: 14, codeName: '轻量化4S网点' },
      { code: 15, codeName: 'NEV专区' },
      { code: 16, codeName: '商超店' },
      { code: 17, codeName: '自修店' },
      { code: 18, codeName: '二级网点' },
      { code: 19, codeName: '车工坊C1' },
      { code: 20, codeName: '车工坊C2' },
      { code: 21, codeName: '车工坊B' },
      { code: 22, codeName: '德科品牌授权经销商' },
      { code: 23, codeName: '单一销售展厅(专区)' },
      { code: 24, codeName: '单一销售展厅(商超)' },
      { code: 99, codeName: '暂定' },
      { code: 0, codeName: '无' }
    ],
    searchItem: {
      type: 'select',
     // mode: 'multiple',
    }
  },
  {
    title: "站点类型",
    name: "dealerTypeCh",
    dataIndex: "dealerTypeCh",
    tableItem: {width: 300},

  },
  {
    title: "新店/老店",
    name: "oldNewShop",
    dataIndex: "oldNewShop",
    tableItem: {width: 100},
    dict: [
      { code: 0, codeName: '新店' },
      { code: 1, codeName: '老店' },
    ],
    searchItem: {
      type: 'select',
    }

  },
  {
    title: "最低配置",
    name: "configCount",
    tableItem: {width: 100},
  },
  {
    title: "考核要求",
    name: "type",
    dataIndex: "type",
    dict: [
      { code: 0, codeName: "路径阶段" },
      { code: 1, codeName: "认证" },
      { code: 2, codeName: "线下课程" },
      { code: 3, codeName: "人员测评" },
      { code: 5, codeName: "个人简历" },
      { code: 6, codeName: "性格测试" },
      { code: 7, codeName: "面试结果" },
      { code: 8, codeName: "电工证" },
      { code: 9, codeName: "岗位认证" },
      { code: 10, codeName: "在线考试" },
      { code: 11, codeName: "在线课程" }
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "考核要求",
    name: "typesCh",
    dataIndex: "typesCh",
    tableItem: {width: 200},

  },
  {
    title: "状态",
    name: "status",
    dataIndex: "status",
    tableItem: {width: 100},
    dict: [
      { code: 0, codeName: "无效" },
      { code: 1, codeName: "有效" }
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "最新修改时间",
    name: "updateTime",
    dataIndex: "updateTime",
    tableItem: {
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        collapse: false,
        buttonSort: ['add','export'],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/requirement/requirementList/requirementAdd"
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出考核要求详情', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      // showAuth: {
      //   title: '适用范围',
      //   dataIndex: 'authData'
      // },
      rowOperateSort: ['update', 'enableOrDisable'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/requirement/requirementList/requirementUpd"
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: {},//状态  0无效  1有效
          textFormat: {
            recordKey: 'status',
            dirt: {  1: '禁用', 0: '启用' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['status'] === 0 ? "启用" : "禁用"
                }该新开业培训？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    status: record['status'] === 1 ? 0 : 1,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "newOpenTrainingRecords",
          custom: true,
          params: { children: "新开业培训记录"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/requirement/requirementList/requirementRecord"
            }
          }
        },

      ],
      commonOperate: {
        add: true,
        update: true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  }
  ,
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },

  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: { }
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
